import { FC } from 'react'
import Auth from 'api/auth'
import { TabListItemProps } from '../../tab/TabList'
import { Button } from '@epidemicsound/design-system/v2'
import { MenuContainer } from '../Menu'
import { smallScreenWidth } from 'hooks/hooks'
import styled from 'styled-components'
import { useSession } from 'next-auth/react'

const StyledMenuContainer = styled.div`
    @media only screen and (max-width: ${smallScreenWidth + 'px'}) {
        display: none;
    }
`

export const Menu: FC = () => {
    const { data: session } = useSession()

    const tabs: TabListItemProps[] = [
        {
            label: 'Dashboard',
            url: `/partners/${session?.partner?.id}/dashboard`,
            match: /^\/portal\/partners\/.*\/dashboard/,
        },
    ]

    const doLogout = () => {
        Auth.logout('DevPortal')
    }

    return (
        <>
            <StyledMenuContainer>
                <MenuContainer tabs={tabs} app={'DevPortal'} />
            </StyledMenuContainer>
            <Button variant="secondary" onClick={doLogout} data-cy-sign-out>
                Sign out
            </Button>
        </>
    )
}
